import React, { Component } from "react";
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: false
        };
    }
    static getDerivedStateFromError(error) {
        return { error: error };
    }
    render() {
        if (!this.state.error) {
            return this.props.children;
        }
        return React.createElement(this.props.fallbackComponent, { error: this.state.error });
    }
}
ErrorBoundary.defaultProps = {
    fallbackComponent: ({ error }) => {
        console.error(error);
        return React.createElement("div", { style: { margin: "20px", textAlign: "center" } },
            React.createElement("h1", null, "Oops, something went wrong"));
    }
};
//# sourceMappingURL=index.js.map